'use strict';

require('./kiwiirccom');


//////////////////
// WEBPACK FOOTER
// ./src/thirdparty/index.js
// module id = AS6v
// module chunks = 1